import { HttpInterceptor, HttpHandler, HttpRequest, 
    HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { AuthenticationService } from '../authentication-service/authentication.service';
import { Router } from '@angular/router';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
    constructor(private authService: AuthenticationService, private router: Router) { }

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {

        return next.handle(req).pipe(
            
            catchError((err: any) => {
                if (err instanceof HttpErrorResponse) {
                    if (err.status === 403) {
                        this.authService.logout();
                        this.router.navigateByUrl('/login');
                    }
                }
                return of(err);
            }));

    }

}
